import { Actions } from './actions';
import {
  GET_SECURITY_UNLOADING_REPORTS_REQUEST,
  GET_SECURITY_UNLOADING_REPORTS_SUCCESS,
  GET_SECURITY_UNLOADING_REPORTS_ERROR,
} from './constants';
// import { SecurityUnloadingReport } from './interfaces';

export const initialState = {
  reports: [] as any,
  loading: false as boolean,
  error: null as null | Error,
};

export type SecurityUnloadingReportState = typeof initialState;

export const reportUnloadingReducer = (state: SecurityUnloadingReportState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_SECURITY_UNLOADING_REPORTS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        reports: [],
      };
    }
    case GET_SECURITY_UNLOADING_REPORTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        reports: action.payload.reports,
      };
    }
    case GET_SECURITY_UNLOADING_REPORTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};
